import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { removeAllLoaderErrors, selectLoaderErrors } from "redux/slices/loader-error.slice";

export function LoaderErrors() {
  const loaderErrors = useAppSelector(selectLoaderErrors);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (loaderErrors.length) {
      loaderErrors.forEach((le) => enqueueSnackbar(le.message, { variant: "error" }));
      dispatch(removeAllLoaderErrors());
    }
  }, [loaderErrors]);

  return <></>;
}
